import {Box, ThemeProvider} from '@primer/react-brand/esm'
import {WebGLPage} from '@github-ui/brand-webgl'
import type {FlexSuiteCategoryPage} from '../types'
import {FlexSuiteSubNav} from '../components/FlexSuiteSubNav'

export type CategoryTemplateProps = {
  page: FlexSuiteCategoryPage
}

export function CategoryTemplate({page}: CategoryTemplateProps) {
  const {template, settings} = page.fields
  const pageColorMode = settings?.fields.colorMode ?? 'light'

  return (
    <ThemeProvider colorMode={pageColorMode}>
      {/* Keep background synchronized with the current color mode */}
      <Box backgroundColor="default">
        <WebGLPage mode={pageColorMode}>
          {template.fields.subNav && <FlexSuiteSubNav subNav={template.fields.subNav} />}
        </WebGLPage>
      </Box>
    </ThemeProvider>
  )
}
